import { AxiosError } from 'axios';
import { useAccountState } from 'contexts/account/account-context';
import { useGet } from 'hooks/use-get';
import React, { useContext } from 'react';
import { UseQueryResult } from '@tanstack/react-query';
import _ from 'underscore';
import { getBluViuNutritionSites } from '../api/get-bluviu-nutrition-sites';
import { BluViuNutritionSite } from '../types/bluviu-nutrition-site.type';

type State = {
  bluViuNutritionSitesQuery: UseQueryResult<BluViuNutritionSite[], AxiosError<unknown, any>>;
};

const BluViuNutritionContext = React.createContext<State | undefined>(undefined);

type BluViuNutritionProviderProps = {
  children: React.ReactNode;
};

const BluViuNutritionProvider: React.FC<BluViuNutritionProviderProps> = ({ children }) => {
  const {
    account: { company },
  } = useAccountState();

  const bluViuNutritionSitesQuery = useGet(
    ['getBluViuNutritionSites', company?.companyId],
    ({ queryKey }) => getBluViuNutritionSites(String(queryKey[1])),
    {
      select: (data) => _.sortBy(data, 'siteName'),
      enabled: !!company?.companyId,
    }
  );

  return <BluViuNutritionContext.Provider value={{ bluViuNutritionSitesQuery }}>{children}</BluViuNutritionContext.Provider>;
};

function useBluViuNutritionState() {
  const context = useContext(BluViuNutritionContext);
  if (context === undefined) {
    throw new Error('useBluViuNutritionState must be used within a BluViuNutritionProvider');
  }
  return context;
}

export { BluViuNutritionProvider, useBluViuNutritionState };
